import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypeUnknownIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.4292 20.859C4.4292 21.4113 4.87693 21.8576 5.42921 21.8576C9.84271 21.8576 14.2234 21.8576 18.8502 21.8576C19.4025 21.8576 19.8502 21.4099 19.8502 20.8576V6.7415C19.8502 6.66042 19.8239 6.58159 19.7753 6.51678L16.4045 2.0224C16.3338 1.92811 16.2228 1.87256 16.1049 1.87256H5.61801C5.32003 1.87256 5.03419 1.99094 4.82349 2.20164C4.61279 2.41242 4.49441 2.69818 4.49441 2.99615L4.4292 11.6104C4.4292 12.1667 4.4292 12.6381 4.4292 13.014C4.4292 13.4215 4.4292 18.6318 4.4292 20.859Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.105 1.87256V5.61791C16.105 5.91588 16.2234 6.20173 16.4341 6.41242C16.6448 6.62312 16.9305 6.7415 17.2286 6.7415H19.8502C19.8502 6.66042 19.824 6.58159 19.7754 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypeUnknownIcon;
